import React from "react";
import { ECCOIcon } from "../../media-and-icons/ecco-icon/ECCOIcon";
import { Box } from "@chakra-ui/react";

interface RatingProps {
    score: number;
    size?: "2xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "3xs" | "xs" | undefined;
}

const Rating: React.FC<RatingProps> = ({ score, size }) => {
    const getStarType = (index: number): "filled" | "partially" | "empty" => {
        const starScore = score - index;

        if (starScore >= 1) return "filled";
        if (starScore >= 0.3) return "partially";
        return "empty";
    };

    // Generate an array of stars
    const stars = Array.from({ length: 5 }, (_, index) => getStarType(index));

    // Render the stars
    return (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            {stars.map((type, index) => (
                <Star key={index} type={type} size={size} />
            ))}
        </Box>
    );
};

interface StarProps {
    type: "filled" | "partially" | "empty";
    size?: "2xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "3xs" | "xs" | undefined;
}

const Star: React.FC<StarProps> = ({ type, size = "2xs" }) => {
    switch (type) {
        case "filled":
            return <ECCOIcon name={"star-filled"} size={size} />;
        case "partially":
            return <ECCOIcon name={"star-partially"} size={size} />;
        case "empty":
        default:
            return <ECCOIcon name={"star-empty"} size={size} />;
    }
};

export default Rating;
